module.exports = __webpack_public_path__ + "img/chevron-black.6d0f2fcb.svg";